export enum TaskState {
  Unspecified = 0,
  Backlog = 10,
  Todo = 20,
  Doing = 30,
  Finished = 40,
}